import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { PlayCircle, Link2, Copy, Trash2, Eye } from "lucide-react";
import { api, errMsg, fmtDate } from "../../lib/api";
import { PageHeader } from "../../components/common";

const COURSES = [["yellow-belt", "Yellow Belt"], ["green-belt", "Green Belt"], ["black-belt", "Black Belt"]];
const shareUrl = (t) => `${window.location.origin}/watch/${t}`;
const copy = async (t) => { await navigator.clipboard.writeText(shareUrl(t)).catch(() => {}); toast.success("Link copied - paste it anywhere to share"); };

export default function AdminVideos() {
  const [links, setLinks] = useState([]);
  const [label, setLabel] = useState({});
  const load = () => api.get("/admin/share-links").then((r) => setLinks(r.data));
  useEffect(() => { load(); }, []);
  const create = async (slug) => {
    try {
      const { data } = await api.post("/admin/share-links", { course_slug: slug, label: label[slug] || "" });
      setLabel({ ...label, [slug]: "" });
      await load();
      copy(data.token);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const revoke = async (t) => { await api.delete(`/admin/share-links/${t}`); toast.success("Link switched off"); load(); };

  return (
    <div>
      <PageHeader eyebrow="Academy" title="Course videos" subtitle="Watch any belt as a learner with everything unlocked, or create a link anyone can open without logging in." />
      <div className="grid md:grid-cols-3 gap-4">
        {COURSES.map(([slug, name]) => (
          <div key={slug} className="dx-card p-5 flex flex-col" data-testid={`av-course-${slug}`}>
            <div className="font-display text-lg font-bold text-[#250E31]">{name}</div>
            <Link to={`/app/learn/${slug}`} className="dx-btn-purple mt-4" data-testid={`av-watch-${slug}`}><PlayCircle className="w-4 h-4" />Watch now</Link>
            <input className="dx-input mt-4" placeholder="Who is this link for? (optional)" value={label[slug] || ""} onChange={(e) => setLabel({ ...label, [slug]: e.target.value })} data-testid={`av-label-${slug}`} />
            <button className="dx-btn-gold mt-2" onClick={() => create(slug)} data-testid={`av-share-${slug}`}><Link2 className="w-4 h-4" />Create shareable link</button>
            <div className="mt-4 space-y-2">
              {links.filter((l) => l.course_slug === slug).map((l) => (
                <div key={l.token} className="rounded-md bg-[#FAF8FC] p-2.5 text-xs" data-testid={`av-link-${l.token}`}>
                  <div className="font-semibold truncate">{l.label || "Shared link"}</div>
                  <div className="text-[#8a7a92] flex items-center gap-1"><Eye className="w-3 h-3" />{l.views} views · {fmtDate(l.created_at)}</div>
                  <div className="flex gap-3 mt-1.5">
                    <button className="font-semibold text-[#5B2A6E] inline-flex items-center gap-1" onClick={() => copy(l.token)} data-testid={`av-copy-${l.token}`}><Copy className="w-3.5 h-3.5" />Copy</button>
                    <a className="font-semibold text-[#5B2A6E]" href={shareUrl(l.token)} target="_blank" rel="noreferrer" data-testid={`av-open-${l.token}`}>Open</a>
                    <button className="font-semibold text-rose-600 inline-flex items-center gap-1 ml-auto" onClick={() => revoke(l.token)} data-testid={`av-revoke-${l.token}`}><Trash2 className="w-3.5 h-3.5" />Switch off</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
